import { render, staticRenderFns } from "./uiNavList.vue?vue&type=template&id=72f106d8&scoped=true"
import script from "./uiNavList.vue?vue&type=script&lang=js"
export * from "./uiNavList.vue?vue&type=script&lang=js"
import style0 from "./uiNavList.vue?vue&type=style&index=0&id=72f106d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f106d8",
  null
  
)

export default component.exports